// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1iJQY","content":"LoadingAlert_content__sAR-A"};